
import { createElement } from "react";
import React from "react";
import { empty, singleton, ofArray, append, fold } from "../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { join, concat } from "../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { reactApi as reactApi_1, reactElement } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { createObj } from "../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { reactApi } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { Dialog as Dialog_1 } from "@headlessui/react";
import { singleton as singleton_1, empty as empty_1, append as append_1, delay, toList } from "../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { useTranslation } from "react-i18next";
import { FormState__getValidation } from "../Shared/Shared.js";
import { ErrorAlert } from "./Alert.js";
import { TextButton } from "./Button.js";
import { unwrap } from "../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";

export function DialogWithClasses(props) {
    let value_18, elems_2, props_2, value_16, props_1, value_11, elems, elems_1;
    const props_3 = ofArray([["open", props.IsOpen], ["onClose", props.OnClose], ["className", fold((a, b) => concat(a, " ", ...b), "", append(ofArray(["relative", "z-50"]), props.Classes))], (value_18 = ofArray([reactElement("div", {
        className: join(" ", ["fixed", "inset-0", "bg-black/30"]),
    }), reactElement("div", createObj(ofArray([["className", join(" ", ["fixed inset-0 flex items-center justify-center p-4", "print:absolute", "print:-top-[80rem]", "print:-left-10"])], (elems_2 = [(props_2 = ofArray([["key", "dialog-panel"], ["className", fold((a_1, b_1) => concat(a_1, " ", ...b_1), "", ofArray(["rounded", "bg-white", "p-8", "min-w-[30rem]", "max-h-[calc(100vh-0.5rem)]", "overflow-auto"]))], (value_16 = ofArray([(props_1 = ofArray([["key", "dialog-title"], (value_11 = singleton(reactElement("div", {
        className: join(" ", ["mb-6", "text-lg", "font-bold"]),
        children: props.Title,
    })), ["children", reactApi.Children.toArray(value_11)])]), reactApi.createElement(Dialog_1.Title, createObj(props_1))), reactElement("div", createObj(ofArray([["className", join(" ", [])], (elems = toList(delay(() => props.Body)), ["children", reactApi_1.Children.toArray(Array.from(elems))])]))), reactElement("div", createObj(ofArray([["className", join(" ", ["mt-7", "flex", "gap-9", "justify-end"])], (elems_1 = toList(delay(() => props.Controls)), ["children", reactApi_1.Children.toArray(Array.from(elems_1))])])))]), ["children", reactApi.Children.toArray(value_16)])]), reactApi.createElement(Dialog_1.Panel, createObj(props_2)))], ["children", reactApi_1.Children.toArray(Array.from(elems_2))])])))]), ["children", reactApi.Children.toArray(value_18)])]);
    return reactApi.createElement(Dialog_1, createObj(props_3));
}

export function Dialog(props) {
    return createElement(DialogWithClasses, {
        Body: props.Body,
        Classes: empty(),
        Controls: props.Controls,
        IsOpen: props.IsOpen,
        OnClose: props.OnClose,
        Title: props.Title,
    });
}

export function ConfirmationDialogWithClasses(props) {
    let elems_1;
    const t = useTranslation()[0];
    let componentState;
    const matchValue = props.FormState;
    let matchResult, formState_1;
    if (matchValue != null) {
        if (matchValue.IsLoading) {
            matchResult = 0;
            formState_1 = matchValue;
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0: {
            componentState = "disabled";
            break;
        }
        default:
            componentState = "enabled";
    }
    return createElement(DialogWithClasses, {
        Body: singleton(reactElement("div", createObj(singleton((elems_1 = toList(delay(() => {
            let matchValue_1, matchValue_2, globalValidationMessage, elems;
            return append_1((matchValue_1 = props.FormState, (matchValue_1 == null) ? (empty_1()) : ((matchValue_2 = FormState__getValidation(matchValue_1, t, "global"), (matchValue_2 == null) ? (empty_1()) : ((globalValidationMessage = matchValue_2, singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["mb-4"])], (elems = [createElement(ErrorAlert, {
                Label: globalValidationMessage,
            })], ["children", reactApi_1.Children.toArray(Array.from(elems))])]))))))))), delay(() => singleton_1(reactElement("div", {
                children: props.Description,
            }))));
        })), ["children", reactApi_1.Children.toArray(Array.from(elems_1))]))))),
        Classes: props.Classes,
        Controls: ofArray([createElement(TextButton, {
            ComponentState: componentState,
            Label: t("general.cancel"),
            OnClick: props.OnClose,
            TestId: "confirmation-dialog-onClose-button",
            Variant: "blueButton",
        }), createElement(TextButton, {
            ComponentState: componentState,
            Label: t("general.confirm"),
            OnClick: props.OnConfirm,
            TestId: "confirmation-dialog-onConfirm-button",
            Variant: "blueButton",
        })]),
        IsOpen: props.IsOpen,
        OnClose: props.OnClose,
        Title: props.Title,
    });
}

export function ConfirmationDialog(props) {
    return createElement(ConfirmationDialogWithClasses, {
        Classes: empty(),
        Description: props.Description,
        FormState: unwrap(props.FormState),
        IsOpen: props.IsOpen,
        OnClose: props.OnClose,
        OnConfirm: props.OnConfirm,
        Title: props.Title,
    });
}

